import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

/**
 * Banner shown when displaying cached backup data due to API rate limits.
 * Dismissible per session (not persisted to localStorage).
 *
 * @param {{ backupAge: string | null }} props
 */
const BackupBanner = ({ backupAge }) => {
  const [dismissed, setDismissed] = useState(false);

  const dismiss = useCallback(() => setDismissed(true), []);

  if (dismissed || !backupAge) return null;

  return (
    <div className="qs-backup-banner" role="alert">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="flex-shrink-0">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
      <span>
        Showing cached data from <strong>{backupAge}</strong>
      </span>
      <span className="qs-backup-banner-sep">·</span>
      <span>API limit reached, live data returns tomorrow</span>
      <button
        type="button"
        className="qs-backup-banner-dismiss"
        onClick={dismiss}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
};

BackupBanner.propTypes = {
  backupAge: PropTypes.string,
};

BackupBanner.displayName = 'BackupBanner';

export default BackupBanner;
